import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialCursor: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17.52 19.805v3.05h1.53v-1.52h6.09v-3.05h-1.52v1.52zm4.57-3.05h1.53v1.53h-1.53Zm-1.52 9.15h1.52v3.04h-1.52Zm0-10.67h1.52v1.52h-1.52Zm-1.52 7.62h1.52v3.05h-1.52Zm0-9.14h1.52v1.52h-1.52Zm-1.53 15.23h3.05v1.53h-3.05Zm0-16.76h1.53v1.53h-1.53ZM16 25.905h1.52v3.04H16Zm0-15.24h1.52v1.52H16Zm-1.53 12.19H16v3.05h-1.53Zm0-13.72H16v1.53h-1.53Zm-1.52 12.2h1.52v1.52h-1.52Zm0-13.72h1.52v1.52h-1.52Zm-1.52 15.24h1.52v1.52h-1.52Zm0-16.76h1.52v1.52h-1.52ZM9.9 24.375h1.53v1.53H9.9Zm0-19.81h1.53v1.53H9.9Zm-3.04-3.04v25.9H9.9v-1.52H8.38V4.565H9.9v-1.52H8.38v-1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialCursor
